<template>
  <div class="p-contentplans-writing-user-headings-item" :data-level="level">
    <div
      class="p-contentplans-writing-user-headings-item__inner"
      :class="{ 'is-alert': error }"
    >
      <div class="p-contentplans-writing-user-headings-item__sort" data-handle>
        <IconDefault type="line3" :size="16" />
      </div>
      <p class="p-contentplans-writing-user-headings-item__label">
        <HeadingType :level="level" />
      </p>
      <div class="p-contentplans-writing-user-headings-item__input c-alertPos">
        <Input :value="value" ref="input" @input="input" />
        <Alert v-if="error">{{ error }}</Alert>
      </div>
      <div
        class="p-contentplans-writing-user-headings-item__toggle"
        ref="button"
        @mouseenter="setPosition"
      >
        <IconDefault type="threeDots" :size="16" />
        <ul class="p-contentplans-writing-user-headings-menu" ref="menu">
          <li
            class="p-contentplans-writing-user-headings-menu__item c-alertPos"
            @click="insertHeading('h2', '')"
          >
            1つ下にh2を追加
            <Alert v-if="errorAdd.h2">{{ errorAdd.h2 }}</Alert>
          </li>
          <li
            class="p-contentplans-writing-user-headings-menu__item c-alertPos"
            @click="insertHeading('h3', '')"
          >
            1つ下にh3を追加
            <Alert v-if="errorAdd.h3">{{ errorAdd.h3 }}</Alert>
          </li>
          <li
            class="p-contentplans-writing-user-headings-menu__item c-alertPos"
            @click="insertHeading('h4', '')"
          >
            1つ下にh4を追加
            <Alert v-if="errorAdd.h4">{{ errorAdd.h4 }}</Alert>
          </li>
          <li
            class="p-contentplans-writing-user-headings-menu__item"
            @click="remove"
          >
            この見出しを削除
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Alert from '@/components/Alert';
import HeadingType from '@/components/HeadingType';
import IconDefault from '@/components/icon/IconDefault';
import Input from '@/components/Input';
import { computePosition, flip, offset } from '@floating-ui/dom';

export default {
  props: {
    errorAddHeading: {
      type: String,
      required: false
    },
    error: {
      type: String,
      required: false
    },
    id: {
      type: String,
      required: false
    },
    level: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: true
    }
  },
  components: {
    Alert,
    HeadingType,
    IconDefault,
    Input
  },
  data() {
    return {
      errorAdd: {
        h2: '',
        h3: '',
        h4: ''
      },
      timeoutId: null
    };
  },
  methods: {
    clearErrorAdd() {
      clearTimeout(this.timeoutId);
      for (const key in this.errorAdd) {
        this.errorAdd[key] = '';
      }
    },
    input(value) {
      this.$emit('input', this.id, this.level, value);
    },
    insertHeading(level, value) {
      if (this.errorAddHeading) {
        this.clearErrorAdd();
        this.errorAdd[level] = this.errorAddHeading;

        this.timeoutId = setTimeout(() => {
          this.errorAdd[level] = '';
        }, 2000);

        return;
      }
      this.$emit('insertHeading', this.id, level, value);
    },
    remove() {
      this.$emit('remove', this.id);
    },
    setPosition() {
      this.$nextTick(() => {
        const buttonEl = this.$refs.button;
        const menuEl = this.$refs.menu;
        if (!buttonEl || !menuEl) {
          return;
        }
        computePosition(buttonEl, menuEl, {
          placement: 'bottom',
          middleware: [flip(), offset(-3)]
        }).then(({ y }) => {
          Object.assign(menuEl.style, { top: `${y}px` });
        });
      });
    }
  }
};
</script>
